module.exports = __webpack_public_path__ + "static/media/fly0156.54b4ea19.webp";